import type { GetSwiggyHeadersResponsePayload } from "@swiggy-private/native-bridge";
import { getBridgeSdk } from "./bridgeSdk";
import { isAndroidPlatform } from "./nativeBridgeHelper";

export const updateStatusBarColor = (
    headers: GetSwiggyHeadersResponsePayload | undefined,
    androidStatusBarColor: string,
    iosStatusBarColor: string,
) => {
    const platform = (headers?.platform || "").toLowerCase();

    if (!isAndroidPlatform(platform)) {
        getBridgeSdk()
            .changeStatusBarColor({ style: iosStatusBarColor })
            .catch(() => void 0);
    } else {
        getBridgeSdk()
            .changeStatusBarColor({
                style: androidStatusBarColor,
                bottomBarMode: iosStatusBarColor,
                statusBarMode: iosStatusBarColor,
            })
            .catch(() => void 0);
    }
};
